export default {
    contractEditor: {
        backToDashboard: 'Nazaj na nadzorno ploščo',
        editContract: 'Uredi pogodbo',
        deliveryLine: 'Dobava: {start} → {end} · Skupaj: {total} · €{price}/MW',
        ref: 'Ref: {value}',
        traded: 'Trgovano: {value}',
        unit: 'Enota: {value}',
        attachments: '{count} priloga | {count} prilog',
        saveRejected: 'Shranjevanje zavrnjeno',
        tabsAria: 'Zavihki urejevalnika pogodb',
        tabBins: 'Košare',
        tabAudit: 'Revizija',
        runningTotals: 'Skupaj (vsota košar): {total} čez {days} dni · {dirty} neshranjeno',
        discard: 'Zavrzi',
        confirmSave: 'Potrdi in shrani',
        discardTitle: 'Zavržem neshranjene spremembe?',
        discardBody: '{count} dan(dni) ima neshranjene spremembe. Z zavrženjem jih boste izgubili.',
    },
}
